var _module_exports ="<div ng-bind-html=\"page.HtmlBody\">\n\n</div>";;
var path = '/app/Main/staticHtmlPage/Main.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;